/**
 * Created by rubin on 2020/6/26.
 */

"use strict";

import http from "../../utils/http";
import store from "../../store";

let fileService = {
  list: function(data, resolve, reject) {
    http({
      url: "/resources/getmemberFileList",
      data,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  createFolder: function(data, resolve, reject) {
    http({
      url: "/resources/createFile",
      data: data,
      method: "post",
    })
      .then((res) => {
        store.dispatch("file/loadFileList");
        store.dispatch("user/updatedUserInfo");
        return resolve(res);
      })
      .catch((err) => reject(err));
  },
  update: function(data, resolve, reject) {
    http({
      url: "/resources/udpateFile",
      data: data,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  delete: function(data, resolve, reject) {
    http({
      url: "/resources/deleteFile",
      data: data,
      method: "post",
    })
      .then((res) => {
        store.dispatch("file/loadFileList");
        store.dispatch("user/updatedUserInfo");
        return resolve(res);
      })
      .catch((err) => reject(err));
  },
  getFolderTree: function(resolve, reject) {
    http({
      url: "/resources/dirTree",
      params: {},
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  transfer: function(data, resolve, reject) {
    http({
      url: "/resources/moveFile",
      data: data,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  copy: function(data, resolve, reject) {
    http({
      url: "/resources/copyFile",
      data: data,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  search: function(params, resolve, reject) {
    http({
      url: "/file/search",
      params: params,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  getBreadcrumbs: function(params, resolve, reject) {
    http({
      url: "/file/breadcrumbs",
      params: params,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  detail: function(params, resolve, reject) {
    http({
      url: "/file",
      params: params,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  secUpload: function(data, resolve, reject) {
    http({
      url: "/resources/checkFileNew",
      data: data,
      method: "post",
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  },
  merge: function(data, resolve, reject) {
    http({
      url: "/file/merge",
      data: data,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  // 获取上传凭证
  getStsInfo: function(data, resolve, reject) {
    http({
      url: "/resources/getStsInfo",
      data: data,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  covertvideoTomp3Batch: function(data, resolve, reject) {
    http({
      url: "/resources/covertvideoTomp3Batch",
      data: data,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
};

export default fileService;
